import * as angular from 'angular';

import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { TicketCreateDialogComponent } from '../ticket-create-dialog/ticket-create-dialog.component';
import { hd, IGroupModel } from '@nx-fe/services';
import { XsI18nPipe } from '@nx-fe/pipes';

type IFilterService = hd.IFilterService;
type ITicketModel = hd.ITicketModel;
type IDeviceModel = hd.IDeviceModel;
type IError = hd.IError;

@Component({
  selector: 'sa-ticket-create',
  template: '',
})
export class TicketCreationComponent implements OnInit, OnDestroy {
  @Input() groups: IGroupModel[];
  @Input() selectedGroupId: string;
  @Output() selectGroup: EventEmitter<string> = new EventEmitter<string>();

  constructor(private saI18nPipe: XsI18nPipe, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.openCreateDialog();
  }

  ngOnDestroy(): void {}

  openCreateDialog = () => {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.data = {
      title: this.saI18nPipe.transform('createTicket_dialog_Title'),
      icon: 'hd-icon icon-xlg hd-icon-createnew',
      Groups: this.groups,
    };

    const dialogRef = this.dialog.open(TicketCreateDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: string) => {
      this.selectGroup.emit(result);
    });
  };
}
